import React, { useEffect, useState } from 'react';
import { Form, Button, Card } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { getSurveyById } from 'services/surveys';
import { getAllQuestionGroups } from 'services/questionGroups';
import PropTypes from 'prop-types';

const ViewSurveyForm = ({ id }) => {
  const [surveyData, setSurveyData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!id) {
      toast.error('No se encontró el ID de la encuesta.', { theme: 'colored' });
      return;
    }

    setLoading(true);
    loadSurveyData(id);
  }, [id]);

  const loadSurveyData = async surveyId => {
    try {
      const surveyResponse = await getSurveyById(surveyId);
      console.log('valor de surveyResponse', surveyResponse);

      if (!surveyResponse.result) {
        toast.error('No se encontró la encuesta.', { theme: 'colored' });
        setLoading(false);
        return;
      }

      const survey = surveyResponse.survey;
      console.log('contenido de survey', survey);

      // Cargar grupos de preguntas
      const groupsResponse = await getAllQuestionGroups(surveyId);
      console.log('contenido de groupsResponse', groupsResponse);

      // Usar la propiedad correcta 'questionGroups' en lugar de 'groups'
      const groups = groupsResponse.result ? groupsResponse.questionGroups : [];
      console.log('contenido de groups', groups);

      if (!Array.isArray(groups) || groups.length === 0) {
        toast.error('No se encontraron grupos de preguntas.', {
          theme: 'colored'
        });
        setLoading(false);
        return;
      }

      // Cargar las preguntas y las opciones de cada grupo
      const groupsWithQuestions = groups.map(group => {
        // Verificamos si el grupo tiene preguntas
        const questions = group.group_questions || [];
        console.log('Preguntas del grupo:', questions);

        // Mapear preguntas y opciones
        const questionsWithOptions = questions.map(question => {
          return {
            ...question,
            options: question.question_options || []
          };
        });

        return {
          ...group,
          questions: questionsWithOptions
        };
      });

      // Asignar grupos a la encuesta
      survey.question_groups = groupsWithQuestions;
      setSurveyData(survey);
    } catch (error) {
      console.error('Error al obtener los datos de la encuesta:', error);
      toast.error('Error al cargar los datos de la encuesta.', {
        theme: 'colored'
      });
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="text-center py-3">Cargando datos de la encuesta...</div>
    );
  }

  if (!surveyData) {
    return <div className="text-center py-3">No se encontró la encuesta.</div>;
  }

  return (
    <Card>
      <Card.Header>
        <h5>{surveyData.name || 'Encuesta sin nombre'}</h5>
        <p>{surveyData.description || 'Sin descripción'}</p>
      </Card.Header>
      <Card.Body>
        {surveyData.question_groups.length > 0 ? (
          surveyData.question_groups.map(group => (
            <div key={group.id} className="mb-4">
              <h6>{group.title || 'Grupo sin título'}</h6>
              <p>{group.description || 'Sin descripción'}</p>
              {group.questions.length > 0 ? (
                group.questions.map(question => (
                  <Form.Group key={question.id} className="mb-3">
                    <Form.Label>
                      {question.question_text || 'Pregunta sin texto'}
                    </Form.Label>
                    {renderQuestionField(question)}
                  </Form.Group>
                ))
              ) : (
                <p className="text-muted">Sin preguntas en este grupo.</p>
              )}
            </div>
          ))
        ) : (
          <p className="text-muted">No se encontraron grupos de preguntas.</p>
        )}
        <div className="d-flex justify-content-end mt-3">
          <Button variant="primary" type="submit" size="sm">
            Guardar Respuestas
          </Button>
        </div>
      </Card.Body>
    </Card>
  );
};

// Función para dibujar el campo de cada pregunta
const renderQuestionField = question => {
  if (!question.options) {
    return <p className="text-muted">No hay opciones disponibles.</p>;
  }

  switch (question.question_type?.name) {
    case 'Texto':
      return <Form.Control type="text" name={`question_${question.id}`} />;
    case 'Opción múltiple':
      return (
        <Form.Select name={`question_${question.id}`}>
          {question.options.map(option => (
            <option key={option.id} value={option.id}>
              {option.option_text}
            </option>
          ))}
        </Form.Select>
      );
    case 'Checkbox':
      return (
        <div>
          {question.options.map(option => (
            <Form.Check
              key={option.id}
              type="checkbox"
              label={option.option_text}
              name={`question_${question.id}_${option.id}`}
            />
          ))}
        </div>
      );
    default:
      return <Form.Control type="text" name={`question_${question.id}`} />;
  }
};

ViewSurveyForm.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

export default ViewSurveyForm;
